export default "__VITE_ASSET__08866ca0__"